import apiClient from '../lib/apiClient';

const contentService = {
  listContents() {
    return apiClient.request('/user/posts');
  },
  generatePost(payload) {
    return apiClient.request('/posts/generate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  generateDesignHtml(payload) {
    return apiClient.request('/design/generate', {
      method: 'POST',
      body: JSON.stringify(payload),
      auth: payload?.session_id ? false : true,
    });
  },
  generateByEndpoint(endpoint, payload, options = {}) {
    return apiClient.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(payload),
      ...options
    });
  },
  generateCreative(payload) {
    return apiClient.request('/creative/generate', {
      method: 'POST',
      body: JSON.stringify(payload),
      auth: payload?.session_id ? false : true,
    });
  },
  getCreativeConversation(creativeId, sessionId = '') {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/creative/${encodeURIComponent(creativeId)}/conversation${suffix}`, {
      auth: !sessionId,
    });
  },
  sendCreativeMessage(creativeId, payload, sessionId = '') {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/creative/${encodeURIComponent(creativeId)}/chat-message${suffix}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      auth: !sessionId,
    });
  },
  myVideos() {
    return apiClient.request('/my-videos');
  },
  editImage(payload) {
    return apiClient.request('/edit-image', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  // === MP vNext: Imagem + Chat Editável ===

  generateCreativeImage(payload) {
    return apiClient.request('/creative/generate-image', {
      method: 'POST',
      body: JSON.stringify(payload),
      auth: payload?.session_id ? false : true,
    });
  },

  editCreative(creativeId, payload, sessionId = '') {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/creative/${encodeURIComponent(creativeId)}/edit${suffix}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      auth: !sessionId,
    });
  },

  uploadCreativeAsset(creativeId, formData, sessionId = '') {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/creative/${encodeURIComponent(creativeId)}/upload-asset${suffix}`, {
      method: 'POST',
      body: formData,
      auth: !sessionId,
    });
  },
};

export default contentService;
